export default class VersionManager {
  static documentsWithVersions = {
    store: {
      terms: [],
      policy: [],
      privacy: [],
      'privacy-3rd-party': [],
      'privacy-3rd-party-non-member': [],
      'privacy-non-member': [],
      adult: [],
      marketing: []
    },
    link: {
      terms: ['2020-08-11', '2021-01-27', '2021-03-25', '2022-03-15', '2025-12-18'],
      privacy: ['2020-08-11', '2021-01-27', '2022-03-15', '2022-04-06', '2025-05-26', '2025-10-01', '2025-12-18', '2026-06-03'],
      adult: [],
      marketing: []
    },
    reelstar: {
      terms: ['2026-05-26'],
      'program-terms': ['2026-09-10']
    },
    business: {
      terms: ['2022-06-14', '2025-05-26'],
      'seeding-terms': ['2026-03-19'],
      'program-terms': ['2026-09-08'],
      privacy: [],
      marketing: []
    },
    deal: {
      terms: ['2025-05-26']
    },
    ai: {
      terms: ['2025-09-23'],
      privacy: ['2025-09-23']
    },
    analyze: {
      'privacy-notification': []
    },
    'spot-match': {
      terms: ['2026-08-25']
    },
    brandedlink: {
      terms: [],
      privacy: []
    },
    commerce: {
      terms: [],
      privacy: [],
      marketing: [],
      consignment: [],
      'customer-privacy': [],
      'customer-privacy-party': [],
      'customer-terms': [],
      'privacy-non-member': []
    },
    payments: {
      terms: [],
      privacy: []
    },
    manager: {
      terms: [],
      privacy: []
    },
    market: {
      terms: [],
      privacy: [],
      brand: {
        privacy: ['2023-12-01', '2024-08-26', '2024-09-10'],
        terms: ['2023-12-01', '2024-08-26', '2024-09-10']
      },
      creator: {
        privacy: ['2023-12-01', '2024-08-26', '2024-09-10'],
        terms: ['2023-12-01', '2024-08-26', '2024-09-10'],
        consignment: []
      },
      member: {
        privacy: ['2023-12-01', '2024-08-26', '2024-09-10'],
        terms: ['2023-12-01', '2024-08-26', '2024-09-10']
      },
      'non-member': {
        terms: ['2023-12-01', '2024-08-26', '2024-09-10']
      }
    }
  }

  constructor(service, paper, type, version) {
    this.service = service
    this.paper = paper
    this.type = type
    this.version = version || 'latest'
  }

  getOtherVersions() {
    return this.type
      ? VersionManager.documentsWithVersions[this.service][this.paper][this.type]
      : VersionManager.documentsWithVersions[this.service][this.paper]
  }

  getDocument() {
    return this.type
      ? import(`@/documents/${this.service}/${this.paper}/${this.type}/${this.getVersion()}.md`)
      : import(`@/documents/${this.service}/${this.paper}/${this.getVersion()}.md`)
  }

  getVersion() {
    if (this.version === 'latest') {
      const otherVersions = this.getOtherVersions()
      if (otherVersions.length) {
        const latestVersion = otherVersions.sort().reverse()[0]
        return latestVersion
      }
    }

    return this.version
  }
}
